import { QueryFunctionContext } from '@tanstack/react-query';
import { api } from '../services/api';
import { IData, IDataNoPagination } from '../types/shared';

export interface IAuditoriaFiscal {
  id: number;
  codi_emp: string | null;
  nome_empresa: string | null;
  dt_referencia: string | null;
  dt_execucao: string | null;
  status: 'OK' | 'ERRO' | 'FATURA' | 'SEM_PASTA';
  faturamento: number | null;

  // PIS
  pis_pdf: number | null;
  pis_calculo: number | null;
  pis_calc_manual: number | null;
  pis_diferenca: number | null;
  pis_erro: string | null;

  // COFINS
  cofins_pdf: number | null;
  cofins_calculo: number | null;
  cofins_calc_manual: number | null;
  cofins_diferenca: number | null;
  cofins_erro: string | null;

  // Retenção
  retencao_pdf: number | null;
  retencao_calculo: number | null;
  retencao_calc_manual: number | null;
  retencao_diferenca: number | null;
  retencao_erro: string | null;

  mensagem_erro: string | null;
  empresa_id: number | null;
}

export interface IAuditoriaFiscalKpi {
  total: number;
  ok: number;
  erro: number;
  fatura: number;
  sem_pasta: number;
}

export interface IAuditoriaFiscalExecucao {
  id: number;
  dt_inicio: string | null;
  dt_fim: string | null;
  dt_referencia: string | null;
  total_processadas: number | null;
  total_ok: number | null;
  total_erro: number | null;
  total_fatura: number | null;
  total_sem_pasta: number | null;
  tempo_execucao: number | null;
  status: string | null;
}

export interface IAuditoriaFiscalImportResponse {
  execucao_id: number;
  total_importadas: number;
  ok: number;
  erro: number;
  fatura: number;
  sem_pasta: number;
}

export const useAuditoriaFiscal = () => {
  const getAuditorias = async (key: QueryFunctionContext): Promise<IData<IAuditoriaFiscal[]>> => {
    const filters = key.queryKey?.[1] ?? {};
    const res = await api.get<IData<IAuditoriaFiscal[]>>('/api/v1/auditoria-fiscal/', {
      params: filters,
    });
    return res.data;
  };

  const getAuditoriasKpi = async (
    key: QueryFunctionContext,
  ): Promise<IDataNoPagination<IAuditoriaFiscalKpi>> => {
    const filters = key.queryKey?.[1] ?? {};
    const res = await api.get<IDataNoPagination<IAuditoriaFiscalKpi>>(
      '/api/v1/auditoria-fiscal/kpi',
      { params: filters },
    );
    return res.data;
  };

  const getExecucoes = async (
    key: QueryFunctionContext,
  ): Promise<IData<IAuditoriaFiscalExecucao[]>> => {
    const filters = key.queryKey?.[1] ?? {};
    const res = await api.get<IData<IAuditoriaFiscalExecucao[]>>(
      '/api/v1/auditoria-fiscal/execucoes',
      { params: filters },
    );
    return res.data;
  };

  const importarLog = async (
    logContent: string,
    dtReferencia?: string,
  ): Promise<IDataNoPagination<IAuditoriaFiscalImportResponse>> => {
    const res = await api.post<IDataNoPagination<IAuditoriaFiscalImportResponse>>(
      '/api/v1/auditoria-fiscal/importar',
      {
        log_content: logContent,
        dt_referencia: dtReferencia,
      },
    );
    return res.data;
  };

  return {
    getAuditorias,
    getAuditoriasKpi,
    getExecucoes,
    importarLog,
  };
};
